import PropTypes from 'prop-types';
import React from 'react';
import ImageSvg from '../images/ImageSvg.react';

const ReactPropTypes = PropTypes;

class ButtonMore extends React.Component {
  static propTypes = {
    onClickButton: ReactPropTypes.func,
  };

  static defaultProps = {
    onClickButton: null,
  };

  render() {
    return (
      <button className="btn btn--f btn--oneIcon" onClick={this.props.onClickButton}>
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <ImageSvg svg="icon-more" iconClass="icon--more" />
            </span>
          </span>
        </span>
      </button>
    );
  }
}

module.exports = ButtonMore;
